import type { QueryKey } from '@tanstack/react-query';
import { http } from 'services/http';
import { CARGO_GET_ONE, DOCUMENTS_GET_MANY } from 'api/query-keys.ts';
import type { DocumentRes, TUpdateDocumentReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateDocument = (documentId: number) => {
  return useMutationBase<DocumentRes, unknown, TUpdateDocumentReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<DocumentRes>(`/v1/documents/${documentId}`, variables);

      return res.data;
    },

    invalidateCallback: ({ cargoId }) => {
      const keys: QueryKey[] = [[DOCUMENTS_GET_MANY]];

      if (cargoId) {
        keys.push([CARGO_GET_ONE, cargoId]);
      }

      return keys;
    },
  });
};
